import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Payment } from '../_models/payment';
import { StripePayment } from '../_models/payment';
import { AuthenticationService } from '../authentication.service';
import { AlertService } from '../components/alert/alert.service';
import { HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DamserviceService {

  constructor(
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private alert: AlertService,
  ) { }

  stripeUrl = 'stripe-payments/'
  api_root: string = environment.REST_API_SERVER;

  public getWorkspaceList() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getBoardsList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getWelcomeBoardsList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/1/get_welcome_board/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getWelcomeAssetsList(workspaceId: any, boardId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/'+boardId+'/images/'+boardId+'/get_welcome_assets/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getSortedImagesList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/get_workspace_images/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getMoveBoardsList(workspaceId: any, boardId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + `workspaces/${workspaceId}/boards/${boardId}/board_list_new/`;
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getTeamList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/team_list/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['my_team'];
    }));
  }

  public addWorkspaceUsers(workspaceId: any, userId: Array<{id: any}>, tag: string, workspaceIds: Array<{id: any}>, roleTitle: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + `workspaces/${workspaceId}/boards/[${userId}]-[${workspaceIds}]-${roleTitle}/add_to_workspaces/`;
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public removeWorkspaceUsers(workspaceId: any, userId: Array<{id: any}>, tag: string, workspaceIds: Array<{id: any}>){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + `workspaces/${workspaceId}/boards/[${userId}]-[${workspaceIds}]/remove_from_worksapce/`;
    const data = {
      "tag": tag
    }
    return this.httpClient.post(url, data)
  }

  public removeUsersPermanently(workspaceId: any, userId: Array<{id: any}>, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + `workspaces/${workspaceId}/boards/[${userId}]/remove_from_team/`;
    const data = {
      "tag": tag
    }
    return this.httpClient.post(url, data)
  }

  public changeImageNameApi(workspaceId: any, boardId: any, imgId: string, imgName: string) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/' +boardId + '/images/'+imgId + '/';
    const data = {
      "title": imgName
    }
    return this.httpClient.patch(similar_url, data).pipe(map(data => {
      return data;
    }));
  }

  public changeUrlsImageNameApi(workspaceId: any, boardId: any, urlId: string, imgName: string) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/' +boardId + '/figma/'+urlId + '/';
    const data = {
      "title": imgName
    }
    return this.httpClient.patch(similar_url, data).pipe(map(data => {
      return data;
    }));
  }

  public createNewBoard(workspaceId: any, boardName: string) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/' + workspaceId + '/boards/';
    const data = {
      "title": boardName
    }

    return this.httpClient.post<any>(url, data);
  }

  public createNewSubBoard(workspaceId: any, boardId: any, boardName: string) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/' + workspaceId + '/boards/' + boardId + '/create_sub_board/';
    const data = {
      "title": boardName
    }

    return this.httpClient.post<any>(url, data);
  }

  public editBoardName(workspaceId: any, boardId: string, newBoardName: string) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/' + workspaceId + '/boards/' + boardId + "/";
    const data = {
      "title": newBoardName
    }
    return this.httpClient.put(url, data)
  }

  public deleteBoard(workspaceId: any, boardName: string, id: any) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+workspaceId+ '/boards/'+ id +'/';
    return this.httpClient.delete(url);
  }

  public archiveBoards(workspaceId: any, boardId: number){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/archieve_boards/`
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data)
  }

  public inviteFriend(email: string, workspaceId: any, roleId: any, return_url: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/invites/';
    const data = {
      "email": email,
      "role": roleId,
      "return_url": return_url
    }

    return this.httpClient.post<any>(url, data);
  }

  public inviteMultipleFriend(email: any, workspaceId: any, roleId: any, return_url: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/invites/1/bulkInvite/';
    const data = {
      "email": email,
      "role": roleId,
      "return_url": return_url
    }

    return this.httpClient.post<any>(url, data);
  }

  public getUsersList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/users/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public getAllUsersList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/team_list_with_owner/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['my_team'];
    }));
  }

  public getOwnerList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/owner/';
    return this.httpClient.get(similar_url);
  }

  public getCurrentUserData(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/current_user_role/';
    return this.httpClient.get(similar_url);
  }

  public editWorkspaceName(workspaceId: any, title: string) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/';
    const data = {
      "title": title
    }
    return this.httpClient.put(similar_url, data)
  }

  public invitedUsersList(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/invites/';
    return this.httpClient.get(similar_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public deleteWorkspaceUser(workspaceId: any, userId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/users/'+ userId +'/';
    return this.httpClient.delete(similar_url);
  }

  public changeUsersRoleApi(workspaceId: any, userId: any,  roleId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/users/'+ userId +'/';
    const data = {
      "role": roleId
    }
    return this.httpClient.put(similar_url, data)
  }

  public changeInvitedUsersRoleApi(workspaceId: any, userId: any,  roleId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/invites/'+ userId +'/';
    const data = {
      "role": roleId
    }
    return this.httpClient.patch(similar_url, data)
  }

  public deleteInvitedUser(workspaceId: any, invites: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/invites/'+ invites +'/';
    return this.httpClient.delete(similar_url);
  }

  public leaveWorkspace(workspaceId: any) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/' + workspaceId + '/leave/';
    return this.httpClient.delete(similar_url);
  }

  public getUsersRoles() {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspace-roles/';
    return this.httpClient.get(similar_url);
  }

  public downloadVersionImages(workspaceId: any, boardId: number, id: number, version: any) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${id}/download_image_version/?version=${version}`
    return this.httpClient.get(url, { responseType: 'blob' })
  }

  public downloadFormatImages(workspaceId: any, boardId: number, id: number, format: any) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${id}/download_image_formats/?download_format=${format}`
    return this.httpClient.get(url, { responseType: 'blob' })
  }

  public downloadImages(workspaceId: any, boardId: number, id: number) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${id}/download_image/`
    return this.httpClient.get(url, { responseType: 'blob' })
  }

   downloadZipFile(workspaceId: any, boardId: number, images_id: Array<{id: any}>) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/"["${images_id}"]"/download_images_zip/`
    return this.httpClient.get(url, { responseType: 'blob' })
  }

  public downloadSharedImages(workspaceId: any, boardId: number, id: number) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${id}/download_shared_image/`
    return this.httpClient.get(url, { responseType: 'blob' })
  }

  public downloadSharedZipFile(workspaceId: any, boardId: number, images_id: Array<{id: any}>) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/"["${images_id}"]"/download_shared_images_zip/`
    return this.httpClient.get(url, { responseType: 'blob' })
  }

  public moveImagesToOtherBoard(workspaceId: any, boardId: number, images_id: Array<{id: any}>, newBoardId: number) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/[${images_id}]${newBoardId}/move_assets/`
    return this.httpClient.post(url, { responseType: 'blob' })
  }

  public imagesExtension(workspaceId: any, boardId: number) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/get_images_extension/`
    return this.httpClient.get(url)
  }

  public getPlanValidity(planId: any) {
    const url = `${environment.REST_API_SERVER}dam-plans/${planId}/get_plan_validity/`
    return this.httpClient.get(url)
  }

  public getSeatAmount(planId: any, seats: any) {
    const url = `${environment.REST_API_SERVER}dam-payment/1/get_upgrade_seats_amount/?plan_id=${planId}&seats=${seats}`
    return this.httpClient.get(url)
  }

  public getAdminsAmount(planId: any, admins: any) {
    const url = `${environment.REST_API_SERVER}dam-payment/1/get_admin_seat_amount/?plan_id=${planId}&admin_seats=${admins}`
    return this.httpClient.get(url)
  }

  public getSeatAmountRazor(planId: any, seats: any) {
    const url = `${environment.REST_API_SERVER}dam-payment/1/get_upgrade_seats_amount_razor/?plan_id=${planId}&seats=${seats}`
    return this.httpClient.get(url)
  }

  public getAdminsAmountRazor(planId: any, admins: any) {
    const url = `${environment.REST_API_SERVER}dam-payment/1/get_admin_seats_amount_razor/?plan_id=${planId}&admin_seats=${admins}`
    return this.httpClient.get(url)
  }

  public getUpgradeSeatAmountRazor(planId: any, seats: any) {
    const url = `${environment.REST_API_SERVER}dam-payment/1/get_plan_upgrade_amount_razor/?target_plan_id=${planId}&new_extra_seat=${seats}`
    return this.httpClient.get(url)
  }

  public deleteImages(workspaceId: any, boardId: number, imageId: number){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${imageId}/`
    return this.httpClient.delete(url)
  }

  public deleteArchivedImages(workspaceId: any, boardId: any, imageId: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${imageId}/delete_archieved_assets/`
    return this.httpClient.delete(url)
  }

  public deleteArchivedBoards(workspaceId: any, boardId: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/delete_archieve_boards/`
    return this.httpClient.delete(url)
  }

  public deleteArchivedFigmaLinks(workspaceId: any, boardId: number, figmaIds: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/figma/${figmaIds}/delete_archieved_figma/`
    return this.httpClient.delete(url)
  }

  public archiveSingleImages(workspaceId: any, boardId: number, imageId: number){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/${imageId}/archieve_assets/`
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data)
  }

  restoreAssets(workspaceId: any, boardId: any, imgId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imgId +'/restore_assets/';
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data);
  }

  restoreFigmaLinks(workspaceId: any, boardId: any, figmaIds: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/figma/'+ figmaIds +'/restore_figma/';
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data);
  }

  restoreBoards(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/restore_boards/';
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data);
  }

  public searchBoards(workspaceId: any, search: string = ""){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/search_boards/`
    let query_params: string = '';

    let search_url = url;
    query_params += "search=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public searchWorkspaces(workspaceId: any, search: string = ""){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/search_workspace/`
    let query_params: string = '';

    let search_url = url;
    query_params += "search=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public searchAdminList(workspaceId: any, search: string = ""){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/search_admin/`
    let query_params: string = '';

    let search_url = url;
    query_params += "search=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url).pipe(map(data => {
      return data['admin_list'];
    }));
  }

  public ownerLeaveAccount(workspaceId: any, ownerId: any, newOwnerId: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/[${ownerId},${newOwnerId}]/transfer_ownership/`
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data)
  }

  public adminsList(workspaceId: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/admin_list/`
    return this.httpClient.get(url).pipe(map(data => {
      return data['admin_list'];
    }));
  }

  public newNotifications(workspaceId: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/notifications/`
    return this.httpClient.get(url);
  }

  public searchImages(workspaceId: any, search: string = ""){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/search_images/`
    let query_params: string = '';

    let search_url = url;
    query_params += "search=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public searchImagesArray(workspaceId: any, search: any){
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/search_images/`
    let query_params: string = '';

    let search_url = url;
    query_params += "search=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url).pipe(map(data => {
      return data['results'];
    }));
  }

  public filterImage(workspaceId: any, boardId: number, search: any) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/images/`
    let query_params: string = '';

    let search_url = url;
    query_params += "image_format=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url);

  }

  public addImageTags(workspaceId: any, boardId: any, imageId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/add_tag/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public addMultipleImageTags(workspaceId: any, boardId: any, imageId: any, tag: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/add_tag/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public addMultipleLibraryTags(libId: any, tag: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/'+ libId +'/add_tag/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public deleteLibraryTags(libraryId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/'+ libraryId +'/remove_tag/';
    const data = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        "tag": tag
      }
    }
    return this.httpClient.delete(url, data);
  }

  public addUrlsImageTags(workspaceId: any, boardId: any, urlId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/figma/'+ urlId +'/add_tag/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public deleteImageTags(workspaceId: any, boardId: any, imageId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/remove_tag/';
    const data = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        "tag": tag
      }
    }
    return this.httpClient.delete(url, data);
  }

  public deleteUrlsImageTags(workspaceId: any, boardId: any, urlId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/figma/'+ urlId +'/remove_tag/';
    const data = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        "tag": tag
      }
    }
    return this.httpClient.delete(url, data);
  }

  public addFavouriteImages(workspaceId: any, imageId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/fav-images/';
    const data = {
      "board_image": imageId
    }
    return this.httpClient.post<any>(url, data);
  }

  public listFavouriteImages(workspaceId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/fav-images/';
    return this.httpClient.get(url);
  }

  public listMyUploadImages(workspaceId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/1/images/my_uploads/';
    return this.httpClient.get(url);
  }

  public listRecentViewedImages(workspaceId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/fav-images/';
    return this.httpClient.get(url);
  }

  public removeFavouriteImages(workspaceId: any, imageId: any, title: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/fav-images/' + imageId +'/';
    const data = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        "title": title
      }
    }
    return this.httpClient.delete(url, data);
  }

  getOTP(email: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/generate_email_otp/';
    const data = {
      "email": email
    }

    return this.httpClient.post<any>(url, data);
  }

  getResetPasswordOTP(email: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/generate_forgot_otp/';
    const data = {
      "email": email
    }

    return this.httpClient.post<any>(url, data);
  }

  resetPassword(email: string, otp: any, password: any, confirmPassword: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/reset_password/';
    const data = {
      "email": email,
      "otp": otp,
      "password": password,
      "confirm_password": confirmPassword,
    }

    return this.httpClient.post<any>(url, data);
  }

  profileEdit: string = 'users/'
  public updateProfiles(id: number, data: any) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + this.profileEdit + id + "/";

    return this.httpClient.patch(url, data).pipe(map(user => {
      const currentUser = this.authenticationService.currentUserValue;
      currentUser.firstName = user['first_name'];
      currentUser.lastName = user['last_name'];
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
      this.authenticationService.updateUser(currentUser);
      // this.alert.success("Profile updated successfully!")
      return user;
    }));;
  }

  postAssetComment(workspaceId: any, boardId: any, imageId: any, replyCommentId: any, commentMsg: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/' + boardId +'/images/' + imageId +'/comment_assets/';
    const data = {
      "parent": replyCommentId,
      "comment": commentMsg
    }

    return this.httpClient.post<any>(url, data);
  }

  getAssetComment(workspaceId: any, boardId: any, imageId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/' + boardId +'/images/' + imageId +'/get_asset_comment/';
    return this.httpClient.get<any>(url);
  }

  deleteAssetComment(workspaceId: any, boardId: any, imageId: any, commentId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/del_asset_comment/';
    const data = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        "comment_id": commentId,
      }
    }
    return this.httpClient.delete(url, data);
  }

  editAssetComment(workspaceId: any, boardId: any, imageId: any, commentId: any, commentMsg: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/edit_asset_comment/';
    const data = {
      "comment_id": commentId,
      "comment": commentMsg
    }
    return this.httpClient.put(url, data)
  }

  resolvedComment(workspaceId: any, boardId: any, imageId: any, commentId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/resolve_comment/';
    const data = {
      "comment_id": commentId,
    }
    return this.httpClient.put(url, data)
  }

  unResolveComment(workspaceId: any, boardId: any, imageId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/get_unresolved_comment/';
    return this.httpClient.get(url)
  }

  resolvedListComment(workspaceId: any, boardId: any, imageId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/get_resolved_comment/';
    return this.httpClient.get(url)
  }

  taggingComment(workspaceId: any, boardId: any, imageId: any, commentId: any, commentMsg: any, userId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/'+ imageId +'/comment_assets/';
    const data = {
      "parent": commentId,
      "comment": commentMsg,
      "tagged_user": userId
    }
    return this.httpClient.post(url, data)
  }

  public deleteImageVersion(workspaceId: any, boardId: any, imageId: any, deleteVersion: any){
    const api_root = environment.REST_API_SERVER;
    const formData: FormData = new FormData();

    formData.append('version', deleteVersion);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/` + imageId +`/delete_version/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  public makeCoverImageVersion(workspaceId: any, boardId: any, imageId: any, version: any){
    const api_root = environment.REST_API_SERVER;
    const formData: FormData = new FormData();

    formData.append('version', version);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/boards/`+ boardId +`/images/` + imageId +`/make_cover/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  submitFeedback(firstName: string, lastName: string, message: string, email: string, rating: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'feedback/';
    const data = {
      "first_name": firstName,
      "last_name": lastName,
      "message": message,
      "email": email,
      "rating": rating,
    }
    return this.httpClient.post(url, data)
  }

  getFeedback(){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'feedback?rating_filter=4,5';
    return this.httpClient.get(url)
  }

  deleteFeedback(feedbackId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'feedback/'+ feedbackId +'/';
    return this.httpClient.delete(url);
  }

  getCustomPaymentData(paymentId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'dam-payment/1/get_customized_plan_data/?payment_id='+paymentId;
    return this.httpClient.get(url)
  }

  getOffersCustomPaymentData(dialogId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_dialog_by_id/?dialog_id='+dialogId;
    return this.httpClient.get(url)
  }

  getFigmaLinks(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/' + workspaceId + '/boards/'+ boardId +'/figma/';
    return this.httpClient.get(url)
  }

  public renameFigmaLinks(workspaceId: any, boardId: any, figmaUrlId: string, imgName: string) {
    this.api_root = environment.REST_API_SERVER;
    let similar_url = this.api_root + 'workspaces/'+workspaceId+'/boards/' +boardId + '/figma/'+figmaUrlId + '/';
    const data = {
      "title": imgName
    }
    return this.httpClient.patch(similar_url, data).pipe(map(data => {
      return data;
    }));
  }

  public trashFigmaLinks(workspaceId: any, boardId: any, figmaId: any) {
    const url = `${environment.REST_API_SERVER}workspaces/${workspaceId}/boards/${boardId}/figma/${figmaId}/archieve_figma/`
    const data = {
      "tag": ""
    }
    return this.httpClient.post(url, data)
  }

  public addFigmaLinkTags(workspaceId: any, boardId: any, figmaId: any, tag: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/figma/'+ figmaId +'/add_tag/';
    const data = {
      "tag": tag
    }
    return this.httpClient.post<any>(url, data);
  }

  public pinBoards(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/pin_board/';
    const data = {
      "tag": ""
    }
    return this.httpClient.post<any>(url, data);
  }

  public unPinBoards(workspaceId: any, boardId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/unpin_board/';
    const data = {
      "tag": ""
    }
    return this.httpClient.post<any>(url, data);
  }

  submitUserPicData(file: File): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;
    const formData: FormData = new FormData();
    formData.append('user_pic', file);
    const req = new HttpRequest('POST', `${api_root}users/set_profile_pic/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.httpClient.request(req);
  }

  getUserPic() {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_profile_pic/';
    return this.httpClient.get(url)
  }

  submitProfileData(title: any, location: any, bio: any) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/set_profile/';
    const data = {
      "title": title,
      "location": location,
      "bio": bio,
    }
    return this.httpClient.post<any>(url, data);
  }

  submitSocialData(linkedinLink: any, twitterLink: any, instagramLink: any, dribbleLink: any, behanceLink: any) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/set_profile_social_link/';
    const data = {
      "linkdin_link": linkedinLink,
      "twitter_link": twitterLink,
      "instagram_link": instagramLink,
      "dribble_link": dribbleLink,
      "behance_link": behanceLink,
    }
    return this.httpClient.post<any>(url, data);
  }

  getProfileData() {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_profile/';
    return this.httpClient.get(url)
  }

  getSocialData() {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_profile_social/';
    return this.httpClient.get(url)
  }

  upload(file: File, imgName: string, workspaceId: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;

    const formData: FormData = new FormData();

    formData.append('image', file);
    formData.append('title', imgName);

    const req = new HttpRequest('POST', `${api_root}workspaces/`+ workspaceId +`/images/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpClient.request(req);
  }

  getUserImage(workspaceId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/images/';
    return this.httpClient.get(url);
  }

  public searchLibrary(search: string = ""){
    const url = `${environment.REST_API_SERVER}cl/`
    let query_params: string = '';

    let search_url = url;
    query_params += "search=" + search
    search_url += '?' + query_params;
    return this.httpClient.get(search_url).pipe(map(data => {
      return data['results'];
    }));
  }

  getMyLibraryContent(){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/';
    return this.httpClient.get(url);
  }

  getDiscoverContent(){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/1/discover_content/';
    return this.httpClient.get(url);
  }

  postLibraryTextContent(title: any, coverImage: any, content: any, dataType: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/';
    const data = {
      "title": title,
      "cover_image": coverImage,
      "text_data": content,
      "data_type": dataType
    }
    return this.httpClient.post<any>(url, data);
  }

  postLibraryImagesUrlContent(title: any, content: any, dataType: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/';
    const data = {
      "title": title,
      "image_content": content,
      "data_type": dataType
    }
    return this.httpClient.post<any>(url, data);
  }

  uploadImagesContentLibrary(title: string, file: File, dataType: any): Observable<HttpEvent<any>> {
    const api_root = environment.REST_API_SERVER;
    const formData: FormData = new FormData();
    formData.append('title', title);
    formData.append('image', file);
    formData.append('data_type', dataType);
    const req = new HttpRequest('POST', `${api_root}cl/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.httpClient.request(req);
  }

  editLibraryContent(title: any, content: any, contentId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/' + contentId + '/';
    const data = {
      "title": title,
      "content": content
    }
    return this.httpClient.put(url, data);
  }

  deleteLibraryContent(contentId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/' + contentId + '/';
    return this.httpClient.delete(url);
  }

  deleteMultipleLibraryContent(contentId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/[' + contentId + ']/del_cl/';
    return this.httpClient.delete(url);
  }

  addDiscoverToMyLibrary(contentIds: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'cl/[' + contentIds + ']/add_cl_lib/';
    const data = {

    }
    return this.httpClient.post<any>(url, data);
  }

  getUserPublicProfileLink(showProjects: any, showSocials: any) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_share_asset_link/';

    let params = new HttpParams()
      .set('share_project', showProjects)
      .set('share_social', showSocials);

    url = `${url}?${params.toString()}`;

    return this.httpClient.get(url)
  }

  getUserUploadedImages() {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_share_assets/';
    return this.httpClient.get(url)
  }

  public deleteUserUploadedImages(assetId: any) {
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/del_share_asset/';
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        asset_id: assetId
      }
    };
    return this.httpClient.delete(url, options);
  }

  public listPublicProfileUploadImages(userToken: string){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'users/get_shared_data/?token='+userToken;
    return this.httpClient.get(url);
  }

  public teamUserRatings(workspaceId: any, userId: any, userRating: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/users/1/rate_team/';
    const data = {
      "user_id": userId,
      "rating": userRating
    }
    return this.httpClient.post<any>(url, data);
  }

  public listGetSuggestedTags(workspaceId: any, boardId: any, imageId: any){
    this.api_root = environment.REST_API_SERVER;
    let url = this.api_root + 'workspaces/'+ workspaceId +'/boards/'+ boardId +'/images/' + imageId + '/get_suggested_tags/';
    return this.httpClient.get(url);
  }
}
